/* Poster Aura — theme behavior. No dependencies. */
(function () {
  'use strict';

  // Header border on scroll + mobile menu
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var toggle = header.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  // Reveal on scroll
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.dataset.step === 'up' ? v + 1 : Math.max(parseInt(input.min || '1', 10), v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product page
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var dataEl = root.querySelector('[data-product-json]');
  if (!dataEl) return;
  var product = JSON.parse(dataEl.textContent);
  var form = root.querySelector('[data-product-form]');
  var idInput = form.querySelector('[name="id"]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var addBtn = form.querySelector('[data-add]');
  var addLabel = addBtn ? addBtn.querySelector('span') : null;
  var track = root.querySelector('[data-track]');
  var thumbs = root.querySelectorAll('[data-thumb]');
  var dots = root.querySelectorAll('[data-dot]');
  var buybar = document.querySelector('[data-buybar]');
  var buybarPrice = buybar ? buybar.querySelector('[data-buybar-price]') : null;
  var buybarVariant = buybar ? buybar.querySelector('[data-buybar-variant]') : null;

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function slides() { return track ? Array.prototype.slice.call(track.children) : []; }

  function goTo(index, smooth) {
    if (!track) return;
    var s = slides()[index];
    if (!s) return;
    track.scrollTo({ left: s.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    setActive(index);
  }

  function setActive(index) {
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
  }

  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });

  if (track) {
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      });
    }, { passive: true });
  }

  function selected() {
    return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  }

  function findVariant(opts) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function update() {
    var opts = selected();
    root.querySelectorAll('[data-option]').forEach(function (fs, i) {
      var label = fs.querySelector('[data-selected-label]');
      var c = fs.querySelector('input:checked');
      if (label && c) label.textContent = c.dataset.label || c.value;
    });
    var v = findVariant(opts);
    if (!v) {
      if (addBtn) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; }
      return;
    }
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (addBtn) {
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    if (buybarPrice) buybarPrice.textContent = money(v.price);
    if (buybarVariant) buybarVariant.textContent = opts.map(function (o) { return o.split(' / ').pop(); }).join(' · ');
    if (v.featured_media) {
      var idx = slides().findIndex(function (s) { return String(s.dataset.mediaId) === String(v.featured_media.id); });
      if (idx > -1) goTo(idx);
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

  root.querySelectorAll('[data-option] input').forEach(function (inp) {
    inp.addEventListener('change', update);
  });

  // Start on the selected variant's image without animating
  (function initImage() {
    var v = product.variants.find(function (x) { return String(x.id) === String(idInput.value); });
    if (v && v.featured_media) {
      var idx = slides().findIndex(function (s) { return String(s.dataset.mediaId) === String(v.featured_media.id); });
      if (idx > 0) requestAnimationFrame(function () { goTo(idx, false); });
    }
  })();

  // Mobile buy bar shows once the main button scrolls out of view
  if (buybar && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { buybar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(addBtn);
    var barBtn = buybar.querySelector('button');
    if (barBtn) barBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click(); });
  }
})();
